import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/menu-icons/dashboard/shortage_qty.png'
import _imports_1 from '../../assets/menu-icons/dashboard/expiries.png'
import _imports_2 from '../../assets/menu-icons/dashboard/near_expiry.png'
import _imports_3 from '../../assets/menu-icons/dashboard/average_bill_value.png'


const _withScopeId = n => (_pushScopeId("data-v-bb172a3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-m-2" }
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-col-12 p-mt-2" }
const _hoisted_4 = { class: "p-d-flex p-jc-between" }
const _hoisted_5 = { class: "store-name p-mt-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-home" }, null, -1))
const _hoisted_7 = { class: "p-grid tile-justify" }
const _hoisted_8 = {
  key: 0,
  class: "p-sm-6 p-lg-2 p-md-3",
  style: {"padding-right":"0 !important"}
}
const _hoisted_9 = { class: "card-body p-p-2 card-styles" }
const _hoisted_10 = { style: {"float":"left","width":"60%"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, " Shortage Quantity ", -1))
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "mt-2 p-mb-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "tiles-desc" }, "Products that need restocking", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"40%","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "dash-icons-style",
    alt: ""
  })
], -1))
const _hoisted_16 = {
  key: 1,
  class: "p-sm-6 p-lg-2 p-md-3",
  style: {"padding-right":"0 !important"}
}
const _hoisted_17 = { class: "card-body p-p-2 card-styles" }
const _hoisted_18 = { style: {"float":"left","width":"60%"} }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, "Expired Products ", -1))
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "mt-2 p-mb-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "tiles-desc" }, "Total expired products in inventory", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"40%","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "dash-icons-style",
    alt: ""
  })
], -1))
const _hoisted_24 = {
  key: 2,
  class: "p-sm-6 p-lg-2 p-md-3",
  style: {"padding-right":"0 !important"}
}
const _hoisted_25 = { class: "card-body p-p-2 card-styles" }
const _hoisted_26 = { style: {"float":"left","width":"60%"} }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, "Upcoming Expiries ", -1))
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "mt-2 p-mb-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "tiles-desc" }, "Products that will expire soon", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"40%","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "dash-icons-style",
    alt: ""
  })
], -1))
const _hoisted_32 = {
  key: 3,
  class: "p-sm-6 p-lg-2 p-md-3",
  style: {"padding-right":"0 !important"}
}
const _hoisted_33 = { class: "card-body p-p-2 card-styles" }
const _hoisted_34 = { style: {"float":"left","width":"60%"} }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-1" }, "Pay Later Balance ", -1))
const _hoisted_36 = { class: "" }
const _hoisted_37 = { class: "mt-2 p-mb-2" }
const _hoisted_38 = { style: {"font-size":"medium"} }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "tiles-desc" }, "Outstanding balance from customers ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"40%","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "dash-icons-style",
    alt: ""
  })
], -1))
const _hoisted_41 = {
  key: 0,
  class: "p-grid"
}
const _hoisted_42 = { class: "p-col-12" }
const _hoisted_43 = { class: "card" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", null, " Sales, Sales Refund, Purchase, Purchase Returns (Last 30 days) ")
], -1))
const _hoisted_45 = { class: "card-body p-p-1" }
const _hoisted_46 = {
  key: 1,
  class: "p-grid p-justify-center p-align-start"
}
const _hoisted_47 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " SALES TODAY ", -1))
const _hoisted_49 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_50 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " RETURNS TODAY ", -1))
const _hoisted_52 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_53 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " NET SALES TODAY ", -1))
const _hoisted_55 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_56 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " SALES MONTH ", -1))
const _hoisted_58 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_59 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " RETURNS MONTH ", -1))
const _hoisted_61 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_62 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " NET SALES MONTH ", -1))
const _hoisted_64 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_65 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " PURCHASES TODAY ", -1))
const _hoisted_67 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_68 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " PURCHASES RETURN TODAY ", -1))
const _hoisted_70 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_71 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " NET PURCHASES TODAY ", -1))
const _hoisted_73 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_74 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " PURCHASES MONTH ", -1))
const _hoisted_76 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_77 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " PURCHASES RETURN MONTH ", -1))
const _hoisted_79 = { class: "p-d-flex p-jc-between card-style" }
const _hoisted_80 = {
  class: "p-col-12 p-md-3 p-lg-4",
  style: {"float":"left"}
}
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " NET PURCHASES MONTH ", -1))
const _hoisted_82 = { class: "p-d-flex p-jc-between card-style" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Chart = _resolveComponent("Chart")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.branchName), 1)
          ]),
          _createElementVNode("div", null, [
            false
              ? (_openBlock(), _createBlock(_component_Dropdown, {
                  key: 0,
                  modelValue: _ctx.branchID,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.branchID) = $event)),
                  options: _ctx.stores,
                  optionLabel: "name",
                  optionValue: "id",
                  placeholder: "Select a Store",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getHomepageDetails()))
                }, null, 8, ["modelValue", "options"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (this.can('stock_alert_report'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "card hover-settings",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.navigateToStockAlertReport && _ctx.navigateToStockAlertReport(...args))),
              style: {"cursor":"pointer"}
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("h4", _hoisted_13, " # " + _toDisplayString(_ctx.dashInfo.shortageQty), 1),
                    _hoisted_14
                  ])
                ]),
                _hoisted_15
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (this.can('stock_expiry_report'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", {
              class: "card hover-settings",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.navigateToExpiryReport && _ctx.navigateToExpiryReport(...args))),
              style: {"cursor":"pointer"}
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("h4", _hoisted_21, " # " + _toDisplayString(_ctx.dashInfo.expired), 1),
                    _hoisted_22
                  ])
                ]),
                _hoisted_23
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (this.can('stock_near_expiry_report'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("div", {
              class: "card hover-settings",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.navigateToNearExpiryReport && _ctx.navigateToNearExpiryReport(...args))),
              style: {"cursor":"pointer"}
            }, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("h4", _hoisted_29, " # " + _toDisplayString(_ctx.dashInfo.upcomingExpiry), 1),
                    _hoisted_30
                  ])
                ]),
                _hoisted_31
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (this.can('transaction_receipt'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _createElementVNode("div", {
              class: "card hover-settings",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.navigatePayLater && _ctx.navigatePayLater(...args))),
              style: {"cursor":"pointer"}
            }, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("h4", _hoisted_37, [
                      _createElementVNode("span", _hoisted_38, "(" + _toDisplayString(_ctx.currency) + ") ", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.dashInfo.payLaterBalance.toFixed(2)), 1)
                    ]),
                    _hoisted_39
                  ])
                ]),
                _hoisted_40
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.can('dashboard_revenue_graph'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_Chart, {
                  type: "line",
                  data: _ctx.multiAxisData,
                  options: _ctx.multiAxisOptions,
                  height: 75
                }, null, 8, ["data", "options"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('dashboard_sales_today'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_48
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.salesToday)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_51
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.returnToday)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_54
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(
                                        _ctx.dashInfo.salesToday -
                                            _ctx.dashInfo.returnToday
                                    )), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_57
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.salesMonth)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_60
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.returnMonth)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_62, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_63
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(
                                        _ctx.dashInfo.salesMonth -
                                            _ctx.dashInfo.returnMonth
                                    )), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_66
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.purchaseToday)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_69
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.purchaseReturnToday)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_72
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(
                                        _ctx.dashInfo.purchaseToday -
                                            _ctx.dashInfo.purchaseReturnToday
                                    )), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_75
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.purchaseMonth)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_78
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(_ctx.dashInfo.purchaseReturnMonth)), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_81
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatAmount(
                                        _ctx.dashInfo.purchaseMonth -
                                            _ctx.dashInfo.purchaseReturnMonth
                                    )), 1)
                ])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}